import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { Paper } from 'components/UI';
import EChart from '../shared/EChart';
import { jsx as ___EmotionJSX } from "@emotion/react";

var summaryStyle = function summaryStyle(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '0.8em',
    marginTop: '1em',
    '& .fund-card': {
      padding: '0.8em',
      backgroundColor: theme.gray50,
      border: "1px solid ".concat(theme.gray100)
    },
    '& .fund-label': {
      fontSize: '1.05rem',
      color: theme.gray400,
      fontWeight: 500,
      marginBottom: '0.2em'
    },
    '& .fund-value': {
      fontSize: '1.4rem',
      color: theme.gray800,
      fontWeight: 600
    }
  };
};

var parseNum = function parseNum(v) {
  return Number(String(v !== null && v !== void 0 ? v : '0').replace(/,/g, ''));
};

var OutstandingChart = function OutstandingChart(_ref) {
  var fundsData = _ref.fundsData,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'EUR' : _ref$currency;
  var theme = useTheme();
  var totals = useMemo(function () {
    if (!fundsData) return null;
    var total = parseNum(fundsData === null || fundsData === void 0 ? void 0 : fundsData.total_balance);
    var available = parseNum(fundsData === null || fundsData === void 0 ? void 0 : fundsData.available_balance);
    return {
      total: total,
      available: available
    };
  }, [fundsData]);
  var option = useMemo(function () {
    if (!totals) return null;
    var unavailable = Math.max(0, totals.total - totals.available);
    var data = [{
      value: totals.available,
      name: 'Налични за раздаване',
      itemStyle: {
        color: theme.primary
      }
    }, {
      value: unavailable,
      name: 'Заети средства',
      itemStyle: {
        color: theme.gray300
      }
    }].filter(function (d) {
      return d.value > 0;
    });
    if (data.length === 0) return null;
    return {
      tooltip: {
        trigger: 'item',
        formatter: "{b}<br/>{c} ".concat(currency, " ({d}%)")
      },
      legend: {
        bottom: 0,
        textStyle: {
          color: theme.gray500,
          fontSize: 11
        },
        itemWidth: 10,
        itemHeight: 10
      },
      series: [{
        type: 'pie',
        radius: ['40%', '65%'],
        center: ['50%', '45%'],
        label: {
          show: false
        },
        emphasis: {
          scale: true,
          scaleSize: 6
        },
        data: data
      }]
    };
  }, [totals, theme, currency]);

  var fmt = function fmt(val) {
    return parseNum(val).toLocaleString('bg-BG', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return ___EmotionJSX(Paper, {
    header: "\u041D\u0430\u043B\u0438\u0447\u043D\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430",
    noPadding: true,
    padding: "1em"
  }, ___EmotionJSX(EChart, {
    option: option,
    height: 220
  }), totals && ___EmotionJSX("div", {
    css: summaryStyle
  }, ___EmotionJSX("div", {
    className: "fund-card"
  }, ___EmotionJSX("p", {
    className: "fund-label"
  }, "\u041E\u0431\u0449\u043E \u0431\u0430\u043B\u0430\u043D\u0441"), ___EmotionJSX("p", {
    className: "fund-value"
  }, fmt(totals.total), " ", currency)), ___EmotionJSX("div", {
    className: "fund-card"
  }, ___EmotionJSX("p", {
    className: "fund-label"
  }, "\u0417\u0430 \u0440\u0430\u0437\u0434\u0430\u0432\u0430\u043D\u0435"), ___EmotionJSX("p", {
    className: "fund-value"
  }, fmt(totals.available), " ", currency))));
};

OutstandingChart.propTypes = {
  fundsData: PropTypes.object,
  currency: PropTypes.string
};
export default OutstandingChart;